import { UseMutationOptions, useMutation } from '@tanstack/react-query';

import { z } from 'zod';

import {
  UpdatePairedSalesStudyError,
  UpdatePairedSalesStudyVariables,
  fetchUpdatePairedSalesStudy,
} from '../toolkitComponents.js';
import { useToolkitContext } from '../toolkitContext.js';
import { Registry } from './registry.js';

type Response = z.infer<typeof schResponse>;
const {
  schemas: { REQUEST: schRequest, RESPONSE: schResponse },
} = Registry.updatePairedSalesStudy;

export const useUpdatePairedSalesStudy = (
  options?: Omit<
    UseMutationOptions<Response, UpdatePairedSalesStudyError, UpdatePairedSalesStudyVariables>,
    'mutationFn'
  >,
) => {
  const { fetcherOptions } = useToolkitContext();

  return useMutation<Response, UpdatePairedSalesStudyError, UpdatePairedSalesStudyVariables>(
    (variables: UpdatePairedSalesStudyVariables) =>
      fetchUpdatePairedSalesStudy({
        ...fetcherOptions,
        ...variables,
        body: schRequest.BODY.parse(variables.body),
      }).then((r) => schResponse.parse(r)),
    options,
  );
};
